import './App.css';
import {
    Button,
    Divider,
    Form,
    Input,
    message,
} from 'antd';
import { Typography } from 'antd';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import cookie from 'react-cookies';
import CryptoJS from "crypto-js";
import React from 'react';

const { Title } = Typography;

const Login = () => {
    const [form] = Form.useForm();
    const n = useNavigate();

    const onLogin = async (values: any) => {
        const name = values.name;
        const password = CryptoJS.MD5(values.password).toString();
        const response = await (
            await fetch('https://api.lynne.com.cn/auth/login', {
                method: 'POST',
                body: JSON.stringify({
                    name,
                    password
                }),
                headers: new Headers({
                    'Access-Control-Allow-Origin': '*',
                    'Content-type': 'Application/json',
                }),
            })
        ).json();
        if (response.success) {
            const expires = new Date(new Date().getTime() + 30 * 24 * 3600 * 1000);
            cookie.save("token", response.token, { expires });
            message.success(response.message);
            setTimeout(() => {
                n('/dashboard');
            }, 200);
        } else {
            message.error(response.message);
        }
    };
    React.useEffect(() => {
        if (cookie.load('token')) {
            n('/dashboard');
        }
    }, []);
    // 渲染数据
    return (
        <>
            <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
                登录~
            </Title>
            <Divider />
            <Form
                layout='vertical'
                form={form}
                name='auth'
                clearOnDestroy
                onFinish={values => onLogin(values)}>
                <Form.Item
                    name='name'
                    label='用户名'
                    rules={[
                        {
                            required: true,
                            message: '请输入用户名',
                        },
                    ]}>
                    <Input />
                </Form.Item>
                <Form.Item
                    name='password'
                    label='密码'
                    rules={[
                        {
                            required: true,
                            message: '请输入密码',
                        },
                    ]}>
                    <Input type='password' />
                </Form.Item>
                <Button type='primary' htmlType='submit'>
                    登录
                </Button>
            </Form>
        </>
    );
};

export default Login;
